module.exports = __webpack_public_path__ + "static/media/Engpic4.7c134d34.png";